'use strict';

var React = require('react');
//	getThumURL = require('thum.io').getThumURL;

var TakeScreenshot = React.createClass({
	displayName: 'TakeScreenshot',

	propTypes: {
		fullpage: React.PropTypes.string.isRequired
	},
	getInitialState: function getInitialState() {
		console.log('props', this.props);
		return {
			url: 'http://www.google.com/',
			screenshotURL: '//image.thum.io/get/http://www.google.com/',
			fullpage: this.props.fullpage
		};
	},

	render: function render() {
		return React.createElement(
			'div',
			{ className: 'take-screenshot-container' },
			React.createElement(
				'p',
				null,
				React.createElement(
					'form',
					{ onSubmit: this.setUrl },
					React.createElement(
						'label',
						{ style: { width: '100px' }, htmlFor: 'url' },
						'URL:'
					),
					React.createElement('input', { size: '50', id: 'url', type: 'text', value: this.state.url, onChange: this.updateUrl }),
					React.createElement('br', null),
					React.createElement(
						'label',
						{ style: { width: '100px' }, htmlFor: 'fullpage' },
						'Full-page:'
					),
					React.createElement('input', { id: 'fullpage', type: 'checkbox', defaultChecked: this.state.fullpage,
						onChange: this.updateFullpage }),
					React.createElement('br', null),
					React.createElement(
						'button',
						{ onClick: this.setUrl, type: 'button' },
						'Generate Screenshot'
					),
					React.createElement('br', null),
					React.createElement(
						'label',
						{ style: { width: '100px' } },
						'Thum.io URL:'
					),
					' http:',
					this.state.screenshotURL,
					React.createElement('br', null)
				)
			),
			React.createElement(
				'p',
				null,
				React.createElement(
					'div',
					{ style: {
							paddingTop: '20px',
							paddingBottom: '20px',
							textAlign: 'center',
							height: '350px',
							width: '350px',
							overflow: 'auto',
							backgroundColor: '#cccccc' } },
					React.createElement('img', { src: this.state.screenshotURL, onLoad: this.postLoad, style: { width: '300px' } })
				)
			)
		);
	},

	setUrl: function setUrl(e) {
		e.preventDefault();

		console.log('setUrl', this.state.url);
		var newUrl = this.state.url;
		if (newUrl.indexOf('http') !== 0) {
			newUrl = 'http://' + newUrl;
		}
		this.setState({ screenshotURL: '/spinners/0.gif',
			url: newUrl });
	},
	postLoad: function postLoad(e) {
		console.log('postload');
		console.log('  fullpage', this.state.fullpage);
		var fullpage = '';
		if (this.state.fullpage) {
			console.log('  loading fullpage');
			fullpage = 'fullpage/';
		}
		this.setState({ screenshotURL: '//image.thum.io/get/png/width/1200/' + fullpage + this.state.url });
	},
	updateUrl: function updateUrl(e) {
		console.log('url=', e.target.value);
		var newUrl = e.target.value;
		this.setState({ url: newUrl });
	},
	updateFullpage: function updateFullpage(e) {
		console.log('fullpage', e.target.checked);
		this.setState({ fullpage: e.target.checked });
	}
});

module.exports = TakeScreenshot;


//////////////////
// WEBPACK FOOTER
// ./client/components/TakeScreenshot.js
// module id = 440
// module chunks = 0